export const styles = theme => ({
  spinner: {
    margin: theme.spacing.unit * 2,
  },
  spinnerWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
});
